<script setup>
import { ref } from 'vue';
import '@sapudex/web-components/dist/Button.js';
import '@sapudex/web-components/dist/Tooltip.js';

const props = defineProps({
  tooltipPosition: { type: String },
});

const tooltipRef = ref(null);

function toggleTooltip(event) {
  event.stopPropagation();

  if (tooltipRef.value) {
    const isOpen = tooltipRef.value.isOpen?.() || false;

    if (isOpen) {
      tooltipRef.value.onClose();
    } else {
      tooltipRef.value.onOpen(event.target);
    }
  }
}
</script>

<template>
  <div class="ml-2 w-fit">
    <button
      class="flex h-[18px] w-[18px] cursor-pointer items-center justify-center border-0 bg-transparent p-0"
      @click="toggleTooltip"
      id="basic-tooltip-btn"
      aria-label="Help information"
      aria-haspopup="dialog"
      role="button"
    >
      <svg class="hover:text-blue-7 text-grey-7 size-4" viewBox="0 0 16 16">
        <use xlink:href="@/assets/question-mark.svg#help-icon"></use>
      </svg>
    </button>

    <udex-tooltip
      ref="tooltipRef"
      id="basic-tooltip"
      horizontal-align="Center"
      vertical-align="Center"
      :placement="props.tooltipPosition"
      automation-id="help-tooltip"
      accessible-name="Help tooltip"
    >
      <p class="tooltip-text body-s-size m-0 text-start">
        <slot name="text"></slot>
      </p>
      <div class="body-s-size text-start">
        <slot name="link"> </slot>
      </div>
    </udex-tooltip>
  </div>
</template>
